export default __webpack_public_path__ + "static/media/DiversityTemplateImg.797fc8c0.png";